import axios from 'axios'

const API_URLS = process.env.REACT_APP_API_URLS

export const getUserProfileDept = async (id: any, startDate: any, endDate: any) => {
  let url = `${API_URLS}/budgets/department/${id}?periodFrom=${startDate}&periodTo=${endDate}`
  try {
    const response = await axios.get(url)
    return Promise.resolve(response.data)
  } catch (error) {
    return Promise.reject(error)
  }
}

export const getDeptTot = async () => {
  let url = `${API_URLS}/budgets/total?periodFrom=2023-11-20&periodTo=2023-11-22`
  try {
    const response = await axios.get(url)
    return Promise.resolve(response.data)
  } catch (error) {
    return Promise.reject(error)
  }
}

export const getGrafik = async () => {
  let url = `${API_URLS}/budgets/department/all?periodFrom=2023-01-20&periodTo=2023-11-22`
  let url2 = `${API_URLS}/summary/reward?year=2023&month=07`
  try {
    const response = await axios.get(url)
    const response2 = await axios.get(url2)
    return Promise.resolve({
      ...response.data,
      reward: response2.data?.rewardTop5 || [],
    })
  } catch (error) {
    return Promise.reject(error)
  }
}

export const generatedReport = async () => {
  let url = `${API_URLS}/budgets/department/points?periodFrom=2023-01-20&periodTo=2023-11-22`
  try {
    const response = await axios.get(url)
    return Promise.resolve(response.data)
  } catch (error) {
    return Promise.reject(error)
  }
}
